module.exports = __webpack_public_path__ + "img/s1.a2e8652c.png";